import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export function useProjectComments(projectId: string) {
  return useQuery({
    queryKey: ['project-comments', projectId],
    queryFn: () => apiClient.get(`/projects/${projectId}/comments`),
    enabled: !!projectId,
  });
}

export function useCreateProjectComment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, content, parentId }: { projectId: string; content: string; parentId?: string }) =>
      apiClient.post(`/projects/${projectId}/comments`, { content, parentId }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['project-comments', variables.projectId] });
      queryClient.invalidateQueries({ queryKey: ['project-activity', variables.projectId] });
    },
  });
}

export function useProjectActivity(projectId: string) {
  return useQuery({
    queryKey: ['project-activity', projectId],
    queryFn: () => apiClient.get(`/projects/${projectId}/activity`),
    enabled: !!projectId,
  });
}
